import { render, staticRenderFns } from "./SuitableResources.vue?vue&type=template&id=3581f6e3"
import script from "./SuitableResources.vue?vue&type=script&lang=ts"
export * from "./SuitableResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3581f6e3')) {
      api.createRecord('3581f6e3', component.options)
    } else {
      api.reload('3581f6e3', component.options)
    }
    module.hot.accept("./SuitableResources.vue?vue&type=template&id=3581f6e3", function () {
      api.rerender('3581f6e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/requests/SuitableResources.vue"
export default component.exports